<style lang="scss">
.channelform .ivu-form-item-error-tip {
    z-index: 99;
}
</style>
<template>
    <div class="channelform">
        <!-- <Breadcrumb class="tablelist-header" v-if="!querytype">
            <BreadcrumbItem to="/">{{$t('erp.channel.product', { defaultValue: '渠道产品' })}}{{type==='edit'?$t('global.common.edit', { defaultValue: '编辑' }):(type==='add'?$t('global.common.add', { defaultValue: '添加' }):$t('global.common.query', { defaultValue: '查看' }))}}</BreadcrumbItem>
        </Breadcrumb> -->
        <compWrapper
            :title="
                $t('global.common.base_information', {
                    defaultValue: '基本信息',
                })
            "
            theme="primary"
        >
            <compBase
                :alltype="type"
                :basedata="compbasedata"
                ref="refbase"
                @on-currency="Allcurrency"
            ></compBase>
        </compWrapper>
        <compWrapper
            :title="
                $t('erp.channel.stock_push_info', {
                    defaultValue: '库存推送信息',
                })
            "
            theme="info"
        >
            <compFormQuery
                v-if="type == 'query'"
                class="margin-top-15 margin-right-15"
                :formdata="getCharge"
                :value="formData"
                :labelWidth="140"
            ></compFormQuery>
            <compFormEdit
                v-else
                class="margin-top-15 margin-right-15"
                :formdata="getCharge"
                v-model="formData"
                :labelWidth="140"
            ></compFormEdit>
        </compWrapper>
        <compWrapper
            :title="$t('erp.channel.price_info', { defaultValue: '价格信息' })"
            theme="info"
        >
            <compPricenews
                :alltype="type"
                :pricedata="comppricedata"
                ref="refprice"
                :compcurrency="newcurrency"
                :otherType="otherType"
            ></compPricenews>
        </compWrapper>
        <compWrapper
            :title="
                $t('global.common.other_information', {
                    defaultValue: '其他信息',
                })
            "
            theme="info"
        >
            <compFormQuery
                v-if="type == 'query'"
                class="margin-top-15 margin-right-15"
                :formdata="getOther"
                :value="formData"
                :labelWidth="140"
            ></compFormQuery>
            <compFormEdit
                v-else
                class="margin-top-15 margin-right-15"
                :formdata="getOther"
                v-model="formData"
                :labelWidth="140"
            ></compFormEdit>
            <template v-if="type != 'query'" slot="footer">
                <vButton
                    class="margin-right-20"
                    theme="primary"
                    @click="validPercent"
                    >{{
                        $t("global.common.save", { defaultValue: "保存" })
                    }}</vButton
                >
                <vButton class="margin-right-20" @click="cancel">{{
                    $t("global.common.cancel", { defaultValue: "取消" })
                }}</vButton>
            </template>
        </compWrapper>
        <compWrapper
            :title="$t('global.log.name', { defaultValue: '操作历史' })"
            theme="gray"
            v-if="type == 'query'"
        >
            <compLog :data="logList"></compLog>
        </compWrapper>
        <compModal
            v-model="modalProps.show"
            v-bind="modalProps"
            @on-close="modalProps.show = false"
        >
            <component
                v-if="modalProps.component"
                :is="modalProps.component"
                v-bind="modalProps.props"
                v-on="modalProps.on"
            />
        </compModal>
        <vLoading loading size="large" transfer v-if="loading"></vLoading>
    </div>
</template>
<script>
import {
    HttpGetChannelOne,
    HttpGetTemplated,
    HttpSaveChannelOne,
    HttpValidPushPercent,
} from "@/service/products/channel";

import compBase from "./compbase";
import compPricenews from "../comppricenews";
import { mapState, mapGetters } from "vuex";
import mixin from "../mixin";
import { HttpSysOpLog } from "@/service/boss/allot";
import { HttpAccountList } from "@/service/boss/dictionary";

export default {
    props: ["activeids", "querytype"],
    mixins: [mixin],
    data() {
        return {
            formData: {
                tempName: "",
                amazonProductSerialStatus: 0,
                handelingTime: 3,
                isPush: "N",
                fbaInventoryType: 1,
            },
            type: this.$route.params.type,
            id: this.$route.query.id,
            compbasedata: {},
            comppricedata: {},
            otherType: "",
            newcurrency: "",
            logList: [],
            modalProps: {
                show: false,
            },
            loading: false,
        };
    },
    components: {
        compWrapper: () => import("@components/templates/wrapper"),
        compFormQuery: () => import("@components/templates/formquery"),
        compFormEdit: () => import("@components/templates/formedit"),
        compLog: () => import("@components/templates/log"),
        compBase,
        compPricenews,
    },
    created() {
        if (this.activeids) {
            this.id = this.activeids;
            this.type = this.querytype;
        } else {
            this.id = this.id;
            this.type = this.type;
        }
        // this.showquery = this.type == 'query' || this.type == 'edit'
        this.getDetail();
    },
    // mounted(){
    // },
    computed: {
        ...mapState("boss", ["accounts"]),
        ...mapGetters("diction", ["getAllProductPerson", "getNewAccountList"]),
        getCharge() {
            return [
                {
                    label: this.$t("erp.channel.is_push_stock", {
                        defaultValue: "是否推送库存",
                    }),
                    key: "isPush",
                    tag: "vRadio",
                    // show: this.type != 'query',
                    valueText:
                        this.formData.isPush == "Y"
                            ? this.$t("erp.global.yes", { defaultValue: "是" })
                            : this.$t("erp.global.no", { defaultValue: "否" }),
                    props: {
                        strict: false,
                    },
                    options: [
                        {
                            trueValue: "Y",
                            label: this.$t("erp.global.yes", {
                                defaultValue: "是",
                            }),
                        },
                        {
                            trueValue: "N",
                            label: this.$t("erp.global.no", {
                                defaultValue: "否",
                            }),
                        },
                    ],
                    formItem: {
                        tip:
                            this.type == "query"
                                ? ""
                                : `<div class="color-error">${this.$t(
                                      "erp.channel.attention_4",
                                      {
                                          defaultValue:
                                              "选择是，会将库存分配计算结果推送至平台且需配合库存推送使用",
                                      }
                                  )}</div>`,
                    },
                },

                {
                    label: "Handling time",
                    key: "handelingTime",
                    tag: "vInput",
                    required: false,
                    formItem: {
                        tip:
                            this.type == "query"
                                ? ""
                                : `<div class="color-error">${this.$t(
                                      "erp.channel.attention_5",
                                      {
                                          defaultValue:
                                              "订单处理时间（从获取订单到有物流信息的时间）仅适用于亚马逊，且需配合库存推送使用",
                                      }
                                  )}</div>`,
                    },
                },
                {
                    label: this.$t("erp.channel.push_percent", {
                        defaultValue: "推送比例(%)",
                    }),
                    key: "pushProportion",
                    tag: "vInputNumber",
                    props: {
                        min: 0,
                    },
                    required: false,
                    formItem: {
                        tip:
                            this.type == "query"
                                ? ""
                                : `<div class="color-error">${this.$t(
                                      "erp.channel.attention_6",
                                      {
                                          defaultValue:
                                              "推送数量=库存分配计算结果*推送比例。不填则默认比例为100%。适用于同一个ERP SKU但在同一渠道对应多个Seller SKU，需要为各个Seller SKU分配比例的情况",
                                      }
                                  )}</div>`,
                    },
                },
                // 6
                {
                    label: "Propert",
                    key: "property",
                    tag: "vInput",
                    query: true,
                    show: this.type == "query" && this.otherType == "amazon",
                },
                // 7
                {
                    label: this.$t("erp.channel.template_name", {
                        defaultValue: "发运模板名称",
                    }),
                    key: "tempName",
                    tag: "vInput",
                    query: true,
                    show: this.type == "query" && this.otherType == "amazon",
                },
            ];
        },
        getOther() {
            return [
                // 1
                {
                    label: "Item Label",
                    key: "fnSku",
                    tag: "vInput",
                    required: false,
                    formItem: {
                        tip:
                            this.type == "query"
                                ? ""
                                : `<div class="color-error">${this.$t(
                                      "erp.channel.attention_7",
                                      {
                                          defaultValue:
                                              "渠道对应的仓库编号，如果是亚马逊则为FNSKU",
                                      }
                                  )}</div>`,
                    },
                },
                // 2
                {
                    label: "Channel Url",
                    key: "channelUrl",
                    tag: "vInput",
                    required: false,
                    formItem: {
                        tip:
                            this.type == "query"
                                ? ""
                                : '<div class="color-error">Channel URL</div>',
                    },
                },
                // 5
                {
                    label: this.$t("erp.channel.is_active_plan", {
                        defaultValue: "是否启用透明计划",
                    }),
                    key: "amazonProductSerialStatus",
                    tag: "vRadio",
                    span: 24,
                    required: false,
                    show: this.otherType == "amazon" && this.type != "query",
                    options: [
                        {
                            trueValue: 1,
                            label: this.$t("erp.global.yes", {
                                defaultValue: "是",
                            }),
                        },
                        {
                            trueValue: 0,
                            label: this.$t("erp.global.no", {
                                defaultValue: "否",
                            }),
                        },
                    ],
                },
                {
                    label: this.$t("erp.channel.is_active_plan", {
                        defaultValue: "是否启用透明计划",
                    }),
                    key: "amazonProductSerialStatus",
                    show: this.otherType == "amazon" && this.type == "query",
                    valueText:
                        this.formData.amazonProductSerialStatus == 1
                            ? this.$t("erp.global.yes", { defaultValue: "是" })
                            : this.$t("erp.global.no", { defaultValue: "否" }),
                },

                // 新增

                {
                    label: "Parent Listing Name",
                    key: "listingName",
                    tag: "vInput",
                    required: false,
                },
                {
                    label: "Parent Asin",
                    key: "asin1",
                    tag: "vInput",
                    required: false,
                },
                {
                    label: this.$t("erp.channel.attr_1", {
                        defaultValue: "属性1",
                    }),
                    key: "listingAttr1",
                    tag: "vInput",
                    required: false,
                },
                {
                    label: this.$t("erp.channel.attr_2", {
                        defaultValue: "属性2",
                    }),
                    key: "listingAttr2",
                    tag: "vInput",
                    required: false,
                },
                {
                    label: this.$t("erp.channel.attr_3", {
                        defaultValue: "属性3",
                    }),
                    key: "listingAttr3",
                    tag: "vInput",
                    required: false,
                },
                {
                    label: "Name",
                    key: "title",
                    tag: "vInput",
                    required: false,
                },
                {
                    label: this.$t("erp.channel.listing_people", {
                        defaultValue: "listing运营人员",
                    }),
                    key: "listingManage",
                    tag: "vSelect",
                    options: this.getAllProductPerson,
                    props: {
                        filterable: true,
                    },
                    required: false,
                },
                {
                    label: this.$t("erp.channel.up_staff_time", {
                        defaultValue: "上架时间",
                    }),
                    key: "amazonTime",
                    tag: "vDatepicker",
                    required: false,
                    props: {
                        format: "yyyy-mm-dd",
                    },
                },
                {
                    label: "Freight Class",
                    key: "freightClass",
                    tag: "vInput",
                    required: false,
                },
                {
                    label: this.$t("erp.channel.fba_stock_config", {
                        defaultValue: "FBA库存配置",
                    }),
                    key: "fbaInventoryType",
                    tag: "vSelect",
                    options: this.getFBAInventoryType,
                    required: false,
                },
            ];
        },
    },
    methods: {
        getDetail() {
            if (this.type == "add") return;
            this.loading = true;
            HttpGetChannelOne({
                id: this.id,
            }).then(
                (res) => {
                    this.handledata(res.data);
                    this.formData = res.data;
                    if (res.data.templateId) {
                        this.templateName(res.data.templateId);
                    }
                    this.loading = false;
                },
                (err) => {
                    this.loading = false;
                    this.$VMessage.error({
                        content: err.message,
                        duration: 30,
                        closable: true,
                    });
                }
            );
            if (this.type == "query") {
                // 请求操作历史
                HttpSysOpLog({
                    search: {
                        EQ_opDataId: this.id,
                        EQ_opModel: "Product_Channel",
                    },
                }).then(
                    (res) => {
                        // console.log(res.data)
                        this.logList = res.data.content;
                    },
                    (err) => {}
                );
            }
        },
        templateName(tempid) {
            HttpGetTemplated({
                id: tempid,
            }).then(
                (res) => {
                    this.$set(this.formData, "tempName", res.data.name);
                },
                (err) => {}
            );
        },
        async handledata(data) {
            await HttpAccountList().then(
                (res) => {
                    const accountList = res.data.map((item) => {
                        return {
                            value: item.flag,
                            label: `${item.title}(${item.flag})`,
                            attach: {
                                id: item.id,
                                siteName: item.siteName,
                                currency: item.currency,
                                type: item.type,
                                status: item.status,
                            },
                        };
                    });
                    const accountItem = accountList.find((item) => {
                        return item.value == data.accountFlag;
                    });
                    // console.log("OtherType", accountItem);
                    this.newcurrency = data.currencyCode;
                    // console.log(accountItem)
                    this.otherType = accountItem.attach.type.toLowerCase();

                    this.$set(this.$data, "compbasedata", data || {});
                    this.$set(this.$data, "comppricedata", data || {});
                },
                (err) => {}
            );
            // let accountItem = this.getNewAccountList.filter(item => {
            // 	if (item.value == data.accountFlag) {
            // 		return item
            // 	}
            // })
            // console.log("OtherType", accountItem);
            // this.newcurrency = data.currencyCode;
            // this.otherType = accountItem[0].attach.type.toLowerCase()

            // this.$set(this.$data, 'compbasedata', data || {})
            // this.$set(this.$data, 'comppricedata', data || {})
        },
        Allcurrency(value) {
            // console.log(value)
            this.newcurrency = value;
        },
        //验证推送百分比
        async validPercent() {
            const valid = await this.$refs["refbase"].validate();
            if (!valid) return;
            this.loading = true;
            const { accountFlag, erpSku, sellerSku, proportion } =
                this.$refs.refbase.formData;
            return HttpValidPushPercent({
                accountFlag,
                erpSku,
                sellerSku,
                proportion,
            })
                .then((res) => {
                    this.loading = false;
                    const message = res.message;
                    if (message) {
                        this.modalProps = {
                            show: true,
                            title: this.$t("erp.channel.valid_push_percent", {
                                defaultValue: "验证推送百分比",
                            }),
                            desc: message,
                            alert: "info",
                            ajaxRequest: async () => {
                                this.modalProps = { show: false };
                                return this.submit();
                            },
                        };
                    } else {
                        return this.submit();
                    }
                })
                .catch((err) => {
                    this.loading = false;
                    this.$VMessage.error({
                        content: err.message,
                        duration: 30,
                        closable: true,
                    });
                });
        },
        async submit() {
            let basedata = this.$refs.refbase.formData;
            let refdata = this.$refs.refprice;

            let flag1 = false;
            // console.log(this.$refs.refbase)
            if (this.$refs.refbase.formData.type == "bundle") {
                this.$refs.refbase.formList.map((item) => {
                    if (item.qty == 0) {
                        flag1 = true;
                    }
                });

                if (flag1) {
                    this.$VMessage.error(
                        this.$t("erp.channel.attention_8", {
                            defaultValue: "组合产品列表中的数量不能为0",
                        })
                    );
                    return;
                }
            }
            if (refdata.formData.businessPriceFlag == true) {
                refdata.formData.productChannelBusiness.quantityPrice1 =
                    refdata.quantityPrice1;
                refdata.formData.productChannelBusiness.quantityPrice2 =
                    refdata.quantityPrice2;
                refdata.formData.productChannelBusiness.quantityPrice3 =
                    refdata.quantityPrice3;
                refdata.formData.productChannelBusiness.quantityPrice4 =
                    refdata.quantityPrice4;
                refdata.formData.productChannelBusiness.quantityPrice5 =
                    refdata.quantityPrice5;

                refdata.formData.productChannelBusiness.percent1 =
                    refdata.present1;
                refdata.formData.productChannelBusiness.percent2 =
                    refdata.present2;
                refdata.formData.productChannelBusiness.percent3 =
                    refdata.present3;
                refdata.formData.productChannelBusiness.percent4 =
                    refdata.present4;
                refdata.formData.productChannelBusiness.percent5 =
                    refdata.present5;
            }
            // if (this.$refs.refbase.formData.type == 'bundle') {
            //     this.$VMessage.warning('组合产品类型下，可能会存在项目不一致的情况！')
            // }
            basedata.productChannelRelateList = this.$refs.refbase.formList;

            let otherdata = {
                isPush: this.formData.isPush,
                handelingTime: this.formData.handelingTime,
                pushProportion: this.formData.pushProportion,

                fnSku: this.formData.fnSku,
                channelUrl: this.formData.channelUrl,
                listingPrice: this.formData.listingPrice,
                listingPriceDate: this.formData.listingPriceDate,
                amazonProductSerialStatus:
                    this.formData.amazonProductSerialStatus,
                property: this.formData.property,
                tempName: this.formData.tempName,
                title: this.formData.title,
                listingName: this.formData.listingName,
                listingAttr1: this.formData.listingAttr1,
                listingAttr2: this.formData.listingAttr2,
                listingAttr3: this.formData.listingAttr3,
                asin1: this.formData.asin1,
                listingManage: this.formData.listingManage,
                amazonTime: this.formData.amazonTime,
                freightClass: this.formData.freightClass,
                fbaInventoryType: this.formData.fbaInventoryType,
            };
            // console.log(otherdata,'ppppp')
            // console.log(newrefdata)
            // console.log(basedata)

            let newrefdata = refdata.formData;
            let data = {
                ...newrefdata,
                ...basedata,
                ...otherdata,
            };
            // console.log(data)
            this.loading = true;
            HttpSaveChannelOne({
                ...data,
                hostOrgId: global.SYSID,
            }).then(
                (res) => {
                    this.$VMessage.success(res.message);
                    this.$router.push({
                        name: "prochannelAdminList",
                    });
                    this.loading = false;
                },
                (err) => {
                    this.$VMessage.error({
                        content: err.message,
                        duration: 30,
                        closable: true,
                    });
                    this.loading = false;
                }
            );
        },
        cancel() {
            if (this.querytype == "edit") {
                this.$emit("on-close");
            } else {
                this.$router.push({
                    name: "prochannelAdminList",
                });
            }
        },
    },
};
</script>
